<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    import * as Share from '@/utils/share'

    export default {
        name: 'app',
        watch: {
            $route() {
                Share.wechat({
                    title: '中国农业大学革命英烈展',
                    desc: '',
                    link: window.location.href,
                    imgUrl: 'https://static.jiaxunyouneng.com/image/bd/e8ed4deeaa4346bd53015b2d326fdc82dc1a00.jpg'
                })
            }
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: Microsoft Yahei,Avenir,Segoe UI,Hiragino Sans GB,STHeiti,Microsoft Sans Serif,WenQuanYi Micro Hei,sans-serif;;
        font-size: 17px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;

        p {
            line-height: 1.8rem;
            margin: 1rem 0;
        }
    }
</style>
